import packageMetadata from "../../package.json";
import { AmplitudeWebSink } from "./adapters/amplitudeWebSink";
import { createBrowserAnalyticsConsentStore } from "./web/analyticsConsent";
import { createBrowserGuestAnalyticsStateStorage } from "./web/guestAnalyticsStateStorage";
import { loadWebAnalyticsRemoteConfig } from "./web/analyticsRuntimePolicy";
import { WebProductAnalyticsRuntime } from "./web/webProductAnalyticsRuntime";

const environment = import.meta.env.PROD
  ? "production"
  : import.meta.env.MODE === "test"
    ? "test"
    : "development";
const analyticsEnabled =
  import.meta.env.VITE_PRODUCT_ANALYTICS_ENABLED === "true";
const analyticsServerZone = import.meta.env.VITE_AMPLITUDE_SERVER_ZONE ?? "";

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
const participation = createBrowserAnalyticsConsentStore(
  () => window.localStorage,
);
const guestAnalyticsStorage = createBrowserGuestAnalyticsStateStorage(
  () => window.localStorage,
);

export const productAnalytics = new WebProductAnalyticsRuntime({
  context: {
    platform: "web",
    environment,
    appVersion: packageMetadata.version,
    buildNumber: import.meta.env.VITE_BUILD_NUMBER ?? "unavailable",
    buildChannel: import.meta.env.PROD ? "web_production" : "web_development",
  },
  localPolicy: {
    explicitlyEnabled: analyticsEnabled,
    serverZone: analyticsServerZone,
  },
  participation,
  guestAnalyticsStorage,
  provider: apiKey ? new AmplitudeWebSink(apiKey) : undefined,
  loadPolicy: () =>
    loadWebAnalyticsRemoteConfig(
      import.meta.env.VITE_PRODUCT_ANALYTICS_CONFIG_URL ??
        "/product-analytics-config.json",
    ),
  scheduleRepeating: (intervalMs, action) => {
    const timer = window.setInterval(action, intervalMs);
    return () => window.clearInterval(timer);
  },
  subscribeToActiveSession: (action) => {
    const handleVisibility = () => {
      if (document.visibilityState === "visible") action();
    };
    window.addEventListener("focus", action);
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      window.removeEventListener("focus", action);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  },
});

export const analyticsParticipation = productAnalytics;
productAnalytics.start();

export * from "./productAnalytics";
export * from "./web/analyticsConsent";
export type { WebAnalyticsParticipation } from "./web/webProductAnalyticsRuntime";
